module.exports = __webpack_public_path__ + "img/sld_inverter_t1_b1_green.05da9065.svg";